var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 22,
    viewBox: "0 0 51 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 22,
    rx: 4,
    fill: "url(#paint0_linear_57_3802)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.992 15H18.312L14.508 9.252V15H12.828V6.612H14.508L18.312 12.372V6.612H19.992V15ZM27.8322 11.532C27.8322 11.772 27.8162 11.988 27.7842 12.18H22.9242C22.9642 12.66 23.1322 13.036 23.4282 13.308C23.7242 13.58 24.0882 13.716 24.5202 13.716C25.1442 13.716 25.5882 13.448 25.8522 12.912H27.6642C27.4722 13.552 27.1042 14.08 26.5602 14.496C26.0162 14.904 25.3482 15.108 24.5562 15.108C23.9162 15.108 23.3402 14.968 22.8282 14.688C22.3242 14.4 21.9282 13.996 21.6402 13.476C21.3602 12.956 21.2202 12.356 21.2202 11.676C21.2202 10.988 21.3602 10.384 21.6402 9.864C21.9202 9.344 22.3122 8.944 22.8162 8.664C23.3202 8.384 23.9002 8.244 24.5562 8.244C25.1882 8.244 25.7522 8.38 26.2482 8.652C26.7522 8.924 27.1402 9.312 27.4122 9.816C27.6922 10.312 27.8322 10.884 27.8322 11.532ZM26.0922 11.052C26.0842 10.62 25.9282 10.276 25.6242 10.02C25.3202 9.756 24.9482 9.624 24.5082 9.624C24.0922 9.624 23.7402 9.752 23.4522 10.008C23.1722 10.256 23.0002 10.604 22.9362 11.052H26.0922ZM38.2745 8.352L36.3305 15H34.5185L33.3065 10.356L32.0945 15H30.2705L28.3145 8.352H30.0185L31.1945 13.416L32.4665 8.352H34.2425L35.4905 13.404L36.6665 8.352H38.2745Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_3802",
    x1: 6,
    y1: -1.92839e-8,
    x2: 51,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A461D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#B85DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7700D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagNew);
export default __webpack_public_path__ + "static/media/tag-new.7341c3f9481cb706167c55d82b3eff26.svg";
export { ForwardRef as ReactComponent };